document.addEventListener('DOMContentLoaded', function () {
    // 全てのアコーディオンボタンを取得
    const accordionButtons = document.querySelectorAll('.sec2__item-button');

    accordionButtons.forEach(button => {
        button.addEventListener('click', function () {
            // クリックされたボタンの親要素内の対象要素を取得
            const currentItem = button.closest('.sec2__item');
            const targetElements = Array.from(currentItem.children).slice(4); // sec2__item-description以降の要素

            targetElements.forEach(element => {
                if (element.classList.contains('is-open')) {
                    // 非表示にする
                    element.style.maxHeight = 0;
                    element.classList.remove('is-open');
                } else {
                    // 表示する
                    element.style.maxHeight = element.scrollHeight + 'px';
                    element.classList.add('is-open');
                }
            });
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    // 各セクション内で高さを揃える関数
    function setEqualHeightInSection(sectionSelector, itemSelector) {
        const sections = document.querySelectorAll(sectionSelector);

        sections.forEach(section => {
            const items = section.querySelectorAll(itemSelector);

            // 2つずつペアを作成して高さを揃える
            for (let i = 0; i < items.length; i += 2) {
                const first = items[i];
                const second = items[i + 1];

                if (!second) continue; // ペアが揃わない場合はスキップ

                // 高さをリセットして再計算
                first.style.height = 'auto';
                second.style.height = 'auto';

                // 2つの高さを比較して大きい方に揃える
                const firstHeight = first ? first.scrollHeight : 0;
                const secondHeight = second ? second.scrollHeight : 0;
                const maxHeight = Math.max(firstHeight, secondHeight);

                first.style.height = `${maxHeight}px`;
                second.style.height = `${maxHeight}px`;
            }
        });
    }

    // 各セクション内で複数の要素の高さを揃える関数
    function setHeights() {
        setEqualHeightInSection('.sec2', '.sec2__item-actor');
        setEqualHeightInSection('.sec2', '.sec2__item-title');
        setEqualHeightInSection('.sec2', '.sec2__item-description');
        setEqualHeightInSection('.sec2', '.sec2__item-info');
    }

    // ページロード時とリサイズ時に実行
    window.addEventListener('load', setHeights);
    window.addEventListener('resize', setHeights);
});